import { render, staticRenderFns } from "./ChecklistItemsList.vue?vue&type=template&id=49a6ca20&scoped=true&"
import script from "./ChecklistItemsList.vue?vue&type=script&lang=js&"
export * from "./ChecklistItemsList.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistItemsList.vue?vue&type=style&index=0&id=49a6ca20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a6ca20",
  null
  
)

export default component.exports